<script>

    import { toast } from 'bulma-toast'
    import { locationsStore, modalStore } from '../stores'

    import LocationsService from '../$services/locations.service'
    import Delete from '../$components/delete.svelte'

    export let location = null

    let loading = false

    async function deleteLocation() {

        loading = true
        const resp = await LocationsService.deleteLocation(location._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        locationsStore.remove(location._id)
        modalStore.close()
        toast({message: 'Dirección borrada', type: 'is-success'})
    }

</script>

<div class="table-container">
    <table class="table is-fullwidth">
        <tbody class="table-informative">
            <tr>
                <th>Alias</th>
                <td>{ location.alias }</td>
            </tr>
            <tr>
                <th>Contacto</th>
                <td>{ location.contact }</td>
            </tr>
            <tr>
                <th>RFC</th>
                <td>{ location.rfc || 'Sin información' }</td>
            </tr>
            <tr>
                <th>Corporación</th>
                <td>{ location.corporate || 'Sin información' }</td>
            </tr>
            <tr>
                <th>Teléfono</th>
                <td>{ location.phone }</td>
            </tr>
            <tr>
                <th>Correo electrónico</th>
                <td>{ location.email }</td>
            </tr>
            <tr>
                <th>Código postal</th>
                <td>{ location.zipcode }</td>
            </tr>
            <tr>
                <th>Estado</th>
                <td>{ location.state }</td>
            </tr>
            <tr>
                <th>Ciudad</th>
                <td>{ location.city }</td>
            </tr>
            <tr>
                <th>Municipio</th>
                <td>{ location.municipality || 'Sin información' }</td>
            </tr>
            <tr>
                <th>Colonia</th>
                <td>{ location.colony }</td>
            </tr>
            <tr>
                <th>Calle</th>
                <td>{ location.street }</td>
            </tr>
            <tr>
                <th>Número</th>
                <td>{ location.number }</td>
            </tr>
            <tr>
                <th>Apartamento</th>
                <td>{ location.apartment || 'Sin información' }</td>
            </tr>
            <tr>
                <th>Referencias</th>
                <td>{ location.references || 'Sin información' }</td>
            </tr>
            <tr>
                <th></th>
                <td>
                    <div class="buttons">
                        <Delete on:confirm={deleteLocation} {loading} />
                        <button on:click={() => modalStore.set('location_update_modal') } class="button is-primary">
                            <span class="icon"><i class="fas fa-edit"></i></span>
                            <span>Editar</span>
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>